import styled from "styled-components";
import infoBg from "./../../resources/images/info/info_bg.png";
import infoBgMobile from "./../../resources/images/info/info_bg_mobile.png";
import {
  darkColor,
  greyTextColor,
  questionDarkTextColor,
  questionTextColor,
} from "../../constants/colors";

const InfoBlock = styled.div`
  //min-height: 100vh;
  flex-grow: 1;
  background-image: url(${infoBg});
  background-position: center top;
  background-size: 100% auto;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  :before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transform: rotate(180deg);
    background: linear-gradient(
      180deg,
      #050237 39.41%,
      rgba(5, 2, 55, 0.7) 96.8%
    );
  }
  @media (max-width: 767px) {
    background-image: url(${infoBgMobile});
  }
  .icons {
    &-wrapper {
      position: relative;
      width: 320px;
      height: 250px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    &-first {
      position: absolute;
      width: 82px;
      height: 82px;
      border-radius: 12px;
      right: 0;
      top: 110px;
    }
    &-second {
      position: absolute;
      width: 102px;
      height: 102px;
      border-radius: 12px;
      left: 0;
      top: 50px;
    }
    &-third {
      position: absolute;
      width: 122px;
      height: 122px;
      border-radius: 16px;
      top: 30px;
      left: 135px;
    }
    &-fourth {
      position: absolute;
      width: 142px;
      height: 142px;
      border-radius: 16px;
      top: 80px;
      left: 60px;
    }
  }
`;

InfoBlock.Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 196px;
  padding-bottom: 75px;
  @media (max-width: 767px) {
    padding-top: 130px;
    padding-bottom: 37px;
  }
  @media (max-height: 668px) {
    padding-top: 35px;
    padding-bottom: 37px;
  }
`;

InfoBlock.Icon = styled.div`
  text-align: left;
  margin-bottom: 16px;
`;
InfoBlock.Top = styled.div``;
InfoBlock.Top.Title = styled.div`
  margin-bottom: 11px;
  h3 {
    color: ${questionTextColor};
    text-align: left;
  }
`;
InfoBlock.Top.Text = styled.div`
  margin-bottom: 19px;
  p {
    color: ${greyTextColor};
    text-align: left;
  }
`;

InfoBlock.Top.Audio = styled.div``;

InfoBlock.Bottom = styled.div``;
InfoBlock.Button = styled.div``;

export { InfoBlock };
